import { render } from "./achieveDetail.vue?vue&type=template&id=245fba67&scoped=true"
import script from "./achieveDetail.vue?vue&type=script&lang=js"
export * from "./achieveDetail.vue?vue&type=script&lang=js"

import "./achieveDetail.vue?vue&type=style&index=0&id=245fba67&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245fba67"]])

export default __exports__